import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./PhotographyCategories.css";

function Photography() {
  const { t } = useTranslation();

  const categories = [
    {
      number: "01",
      key: "weddings",
      className: "weddings-category",
      image:
        "https://i.postimg.cc/GpNhZDzy/Whats-App-Image-2026-08-18-at-9-55-44-PM.jpg",
    },

    {
      number: "02",
      key: "islamicWeddings",
      className: "islamic-weddings-category",
      image:
        "https://i.postimg.cc/jjWRQ5KC/Whats-App-Image-2026-08-18-at-9-55-53-PM.jpg",
    },

    {
      number: "03",
      key: "engagements",
      className: "engagements-category",
      image:
        "https://i.postimg.cc/Bv1GPVcb/Whats-App-Image-2026-08-18-at-9-55-47-PM.jpg",
    },

    {
      number: "04",
      key: "bridalSessions",
      className: "bridal-category",
      image:
        "https://i.postimg.cc/gjg7TVHr/Whats-App-Image-2026-08-18-at-9-55-42-PM.jpg",
    },

    {
      number: "05",
      key: "womenEvents",
      className: "women-category",
      image:
        "https://i.postimg.cc/T1Nk9RTT/Whats-App-Image-2026-08-18-at-9-55-49-PM.jpg",
    },

    {
      number: "06",
      key: "familyFriends",
      className: "mixed-category",
      image:
        "https://i.postimg.cc/NGn7pC1x/Whats-App-Image-2026-08-18-at-9-55-54-PM.jpg",
    },
  ];

  return (
    <section
      className="photography-categories"
      id="photography-categories"
    >
      {/* ================= HEADING ================= */}

      <div className="photography-categories-heading">
        <span className="photography-label">
          {t("photography.label")}
        </span>

        <h2>
          {t("photography.title1")}
          <br />
          <span>{t("photography.title2")}</span>
        </h2>

        <div className="photography-divider">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>
      </div>

      {/* ================= CATEGORIES ================= */}

      <div className="photography-circles">
        {categories.map((category) => {
          const categoryName = t(
            `photography.categories.${category.key}.name`
          );

          const categoryText = t(
            `photography.categories.${category.key}.text`
          );

          return (
            <Link
              key={category.key}
              to={`/gallery/Photography/${encodeURIComponent(
                categoryName
              )}`}
              className={`photography-category-circle ${category.className}`}
              style={{
                backgroundImage: `url("${category.image}")`,
              }}
            >
              {/* Overlay */}

              <div className="photography-circle-overlay"></div>

              {/* Content */}

              <div className="photography-circle-content">
                <span className="photography-number">
                  {category.number}
                </span>

                <h3>{categoryName}</h3>

                <div className="photography-small-line">
                  <span></span>
                  <i>✦</i>
                  <span></span>
                </div>

                <p>{categoryText}</p>

                <div className="photography-arrow">
                  ↗
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default Photography;